export const HOST = ['https://test-static-tradeup-cn.oss-cn-beijing.aliyuncs.com', 'https://download.ftfast.com'];
export const API = {
    apk: '/tradeup/download/TradeUP_latest.apk'
};
